// Keep in sync with `export_data_catalog_dataset_step_shapes.py`
export enum ExportDataCatalogDatasetVariableName {
  DATASET_NAME = 'datasetName',
  FOLDER_ID = 'folderId',
}

// Keep in sync with `send_to_document.yaml`
export enum SendToDocumentVariableName {
  DOCUMENT_ID = 'documentId',
  SECTION_INDEX = 'sectionIndex',
}

// Keep in sync with `data_catalog_file.yaml`
export enum DataCatalogFileVariableName {
  FILE_ID = 'fileId',
}

// Keep in sync with `data_catalog_files.yaml`
export enum DataCatalogFilesVariableName {
  FILE_IDS = 'fileIds',
}
